import { Box, MenuItem, SelectChangeEvent } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { storageKeys } from 'shared/constants';
import { AppLanguage } from 'shared/enums';
import { FlagGb, FlagPl } from 'shared/icons/Flags';
import { FlagContainer, FlagSelectContainer, StyledSelect } from './StyledComponents';

export const LanguageSelect = () => {
	const { i18n } = useTranslation();
	const [language, setLanguage] = useState(i18n.language);

	const handleChange = (event: SelectChangeEvent<unknown>) => {
		const newLanguage = event.target.value as string;
		setLanguage(newLanguage);
		i18n.changeLanguage(newLanguage);
		localStorage.setItem(storageKeys.I18NEXTLNG, newLanguage);
	};

	const handleRenderFlag = (value: AppLanguage) => {
		switch (value) {
			case AppLanguage.Polish:
				return <FlagPl />;
			case AppLanguage.English:
				return <FlagGb />;
			default:
				<></>;
		}
	};

	const handleRenderLanguageName = (value: AppLanguage) => {
		switch (value) {
			case AppLanguage.Polish:
				return 'Polski';
			case AppLanguage.English:
				return 'English';
			default:
				<></>;
		}
	};

	useEffect(() => {
		if (i18n.languages[0] === language) {
			localStorage.setItem(storageKeys.I18NEXTLNG, language);
		}
	}, []);

	return (
		<StyledSelect
			variant='standard'
			value={language}
			onChange={handleChange}
			fullWidth
			MenuProps={{
				disableScrollLock: true,
			}}
			renderValue={(selected: any) => (
				<Box display='flex' alignItems='center'>
					<FlagSelectContainer>{handleRenderFlag(selected as AppLanguage)}</FlagSelectContainer>
					<Box ml={1}>{handleRenderLanguageName(selected as AppLanguage)}</Box>
				</Box>
			)}
		>
			<MenuItem id='menu-language-select-item-polish' value={AppLanguage.Polish}>
				<FlagContainer>
					<FlagPl />
				</FlagContainer>
				{handleRenderLanguageName(AppLanguage.Polish)}
			</MenuItem>
			<MenuItem id='menu-language-select-item-english' value={AppLanguage.English}>
				<FlagContainer>
					<FlagGb />
				</FlagContainer>
				{handleRenderLanguageName(AppLanguage.English)}
			</MenuItem>
		</StyledSelect>
	);
};
